import Vue from 'vue';
import config from '../../config/index';

export default {
  // 获取管理员下拉列表
  getSysUserList() {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysUser/list`);
  },
  // 获取子系统列表
  getSysList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysApp/page`, { params });
  },
  // 修改子系统状态
  postSysStatus(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysApp/changeStatus`, params);
  },
  // 分配子系统超管
  postSysAdmin(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysApp/grantManager`, params);
  },
  // 新增子系统
  postNewSys(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysApp/add`, params);
  },
  // 编辑子系统
  postEditSys(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysApp/edit`, params);
  }
};
